import { ReactNode } from 'react';
import Modal from '@material-ui/core/Modal';
import classnames from 'classnames';
import {FaXmark} from "react-icons/fa6";


interface BaseModalProps {
    children: ReactNode
    headerText: string;
    isVisible: boolean;
    cancelAction: (input?: any | null) => void,
    className?: string,
}

export const BaseModal = ({
    children,
    headerText,
    isVisible,
    cancelAction,
    className=null,
}: BaseModalProps) => (
    <Modal
            open={isVisible}
            onClose={cancelAction}
            className={classnames("custom-modal", className)}
    >
        <div className={classnames("modal-container", "rounded", "shadow")}>
                <div className={classnames("header", "d-flex", "justify-content-between")}>
                    <div className={classnames("pt-4", "mx-4")}>
                        <p>{headerText}</p>
                    </div>
                    <div className={classnames("mt-3", "me-3")}>
                        <button
                            type="button"
                            onClick={cancelAction}
                        >
                            <FaXmark size={26} />
                        </button>
                    </div>
                </div>
                {children}
            </div>
    </Modal>
);
